"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SvgIcon_1 = require("./internal/SvgIcon");

exports.Cloud = function (props) {
  return react_1.default.createElement(SvgIcon_1.SvgIcon, tslib_1.__assign({}, props), react_1.default.createElement("svg", {
    viewBox: "0 0 16 16"
  }, react_1.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.23145 11.2842H10.3242C10.8301 11.2705 11.2607 11.0859 11.6162 10.7305C11.9717 10.375 12.1494 9.94206 12.1494 9.43164C12.154 8.92122 11.974 8.48828 11.6094 8.13281C11.2448 7.77734 10.8073 7.59961 10.2969 7.59961C10.1237 7.59961 9.94596 7.62695 9.76367 7.68164C9.61328 7.21679 9.34212 6.83626 8.9502 6.54004C8.55371 6.24381 8.07748 6.0957 7.52148 6.0957C6.96549 6.0957 6.47103 6.30989 6.03809 6.73828C5.60058 7.16211 5.36816 7.67708 5.34082 8.2832L5.23145 8.26953C4.81673 8.26953 4.46126 8.41536 4.16504 8.70703C3.86881 8.9987 3.7207 9.35416 3.7207 9.77344C3.7207 10.1882 3.86653 10.5436 4.1582 10.8398C4.45899 11.1361 4.81673 11.2842 5.23145 11.2842ZM5.19043 13C4.31087 13 3.55892 12.6878 2.93457 12.0635C2.31022 11.4391 1.99805 10.6872 1.99805 9.80762C1.99805 9.14225 2.18945 8.54069 2.57227 8.00293C2.95508 7.46517 3.4541 7.08464 4.06934 6.86133C4.35645 5.92252 4.8304 5.25944 5.49121 4.87207C6.15202 4.48926 6.83105 4.29785 7.52832 4.29785C8.22559 4.29785 8.84538 4.4528 9.3877 4.7627C9.93002 5.07259 10.347 5.48958 10.6387 6.01367C11.5684 6.04102 12.3636 6.38281 13.0244 7.03906C13.6852 7.69532 14.0156 8.50423 14.0156 9.46582C14.0156 10.4274 13.6647 11.2568 12.9629 11.9541C12.2611 12.6514 11.4203 13 10.4404 13H5.19043Z",
    clipRule: "evenodd"
  })));
};